import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {TranslateService} from '@ngx-translate/core';
import {setLanguage} from "@app/store";
import {tap} from "rxjs";

@Injectable()
export class LanguageEffects {
  private actions$ = inject(Actions);
  private translate = inject(TranslateService);

  syncToTranslate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setLanguage),
        tap(({language}) => {
          this.translate.use(language);
        })
      ),
    {dispatch: false}
  );


}
